module.exports = __webpack_public_path__ + "img/course_bg_01.0ae0e79a.png";